import Map from "@/Components/Map/Map";
import useBranch from "@/shared/atoms/useBranch";
import { ZipcodesTableDataRequest } from "@/shared/utils/interfaces";
type Props = {
  data?: ZipcodesTableDataRequest[];
};
const ZipcodeMap = ({ data }: Props) => {
  const branch = useBranch()[0];

  return (
    <Map
      showSearchWidget={false}
      showZipcodes
      height={"100%"}
      branch={branch}
      zipcodes={data || []}
    />
  );
};

export default ZipcodeMap;
